export default __webpack_public_path__ + "static/media/blog7.b6f55b20.jpg";